import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=894e770a&scoped=true&"
import script from "./CustomTable.vue?vue&type=script&lang=js&"
export * from "./CustomTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=894e770a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894e770a",
  null
  
)

export default component.exports